module.exports = __webpack_public_path__ + "img/Lif-mobile-2.03d4ec71.png";